exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-button[data-v-a327286e] {\n  margin-top: 5px;\n}\n.action-buttons[data-v-a327286e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 8px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports
